import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MetricDetails } from '../../../models/package-center.model';
import { Tabs } from '../data-management.component';
import { MetricsService } from './metrics.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { MatDialogCloseEvent, Mode } from '../../../const';
import { HttpErrorResponse } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html'
})
export class MetricsComponent implements OnInit, OnChanges {

  @ViewChild('metricEditForm', { static: true }) metricEditFormDialog!: TemplateRef<any>;
  @Output() setPageTitle = new EventEmitter<{}>();
  @Output() close = new EventEmitter<void>();
  @Input() showForm: boolean = false;
  @Input() isCurrentTab: string = "";
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";
  
  isEdit: boolean = false;
  metricToEdit: MetricDetails = {} as MetricDetails;
  tabs = Tabs;
  metrics: MetricDetails[] = [];
  metricsForCreate: MetricDetails[] = [];
  metricEditFormRef: MatDialogRef<any> | undefined;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  sortMetricNameAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";
  sortSubcategoryNameAsc: boolean = true;

  metricForm: FormGroup = new FormGroup({
    metricName: new FormControl([], [
      Validators.required
    ])
  });

  constructor(private metricsService: MetricsService,
              private toasterService: ToastrService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getMetrics();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.searchTriggered){
      
      this.pageNumber = 0
      this.pageOffSet = 0;
      this.getMetrics();
    }
  }

  getMetrics(sortColumn = "", sortDirection = ""){
    let sectorId = Number(sessionStorage.getItem('sector'));
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";

    this.metricsService.getMetrics(sectorId, payload).subscribe((response: MetricDetails[] | any)=>{
      this.metrics = response;
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.metricForm.reset();
      this.metricsForCreate = this.metrics;
      this.showForm = false;
      this.isEdit = false;
      this.close.emit();
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getMetrics();
  }
  
  patchMetricDetails(metricDetail: MetricDetails){
    this.metricForm.patchValue(metricDetail);
  }

  editMetric(){
    let metricDetail : MetricDetails = JSON.parse(JSON.stringify(this.metricForm.value))
    metricDetail.metricId = this.metricToEdit.metricId;
    this.metricsService.updateMetricName(metricDetail).subscribe((res=>{
      this.toasterService.success("Metric updated successfully", "Success");
      this.getMetrics();
      this.closeCreateForm();
    }),(error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  deleteMetric(metricDetail: MetricDetails){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the metric?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.metricsService.deleteMetric(metricDetail.metricId).subscribe((res)=>{
          if(res){
            this.toasterService.success("Metric deleted successfully!","Success");
            this.getMetrics();
          }
        },(error: HttpErrorResponse)=>{
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    });
  }

  activateDeactivateMetric(metricDetail: MetricDetails){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: metricDetail.status,
        message: "Are you sure want to" + (metricDetail.status ? " inactivate" : " activate") + " the metric?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.metricsService.updateMetricStatus(metricDetail.metricId).subscribe((res)=>{
          if(res){
            this.toasterService.success("Metric" + (metricDetail.status ? " activated" : " inactivated") + " successfully","Success");
            this.getMetrics();
          }
        },(error: HttpErrorResponse)=>{
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
          metricDetail.status = !metricDetail.status;
        })
      }
      else{
        metricDetail.status = !metricDetail.status;
      }
    });
  }

  patchForm(metricDetail: MetricDetails){
    this.setPageTitle.emit({
      tab: this.tabs.Module,
      mode: Mode.Edit
    })
    this.isEdit = true;
    this.metricForm.patchValue(metricDetail);
    this.showForm = true;
    this.metricToEdit = metricDetail;

    this.metricEditFormRef =  this.dialog.open(this.metricEditFormDialog,{
      width: '400px'
    });
  }

  showCreateForm() {
    this.metricForm.reset();
    this.showForm = true;
    this.isEdit = false;
    this.setPageTitle.emit(
      {
        tab: this.tabs.Module,
        mode: Mode.Create
      }
    );
  }

  closeCreateForm() {
    this.metricForm.reset();
    this.showForm = false;
    this.close.emit();
    this.dialog.closeAll();
  }
}
